import classNames from "classnames";
import styles from "./MatchCountChip.module.scss";

interface Props {
    label: string;
    isSuggested?: boolean;
}

/** The "2 invoices" / "2 schedules" count next to a match or schedule. */
export function MatchCountChip({ label, isSuggested }: Props) {
    return (
        <span
            className={classNames(styles.chip, {
                [styles.suggested]: isSuggested,
            })}
        >
            {label}
        </span>
    );
}
